<template>
	<div class="p_searchresult" v-if="search_key!==''">
		<ul class="p_search_listing">
            <li v-for="i in searchResult.slice(0, 200)">
                <span class="scripname">{{ beautifyname(i) }} </span>   
                <div class="pull-right">
                    <span class="sciprice">{{main_exchange_name[i.exch]}}</span>
                    <div class="scipoption" @click="subscribe([i.isinid]);subscribeMarketDepth(i.isinid)">
                        <router-link :to = "{path:'/MarketDetails', query: { isinid: i.isinid }}" class="p_btn" v-on:click.native="search_key=''">
							<i class="fa fa-bar-chart"></i>
						</router-link>
                    </div>
                </div>
            </li>
        </ul>
    </div>
  	
</template>
<script>
	import { PriceFeedProviderConst } from '@/plugins/vue-provider-cache/provider/ws-price-feed/price-feed-provider.lib'
  	export default {
	    name: 'searchbar',
	    props:['searchCache', 'unsubscribe', 'subscribe', 'search_text', 'subscribeMarketDepth', 'isinid'],
	    data() {
	      return {
	      	"search_key":"",
	      	"show_list":"-1",
	      	"select_tab": -1,
	      	"select_exch": '-1',
	      	"selectExpiry":'',
	      	"searchResult": [],
	      	"selectOption": '',
	      	"strikePriceValue":'',
	      	"searchStringIsin":'',
	      	"sortviaE": "",
	      	monthBig: ["january","february","march","april","may","june","july",
			        "august","september","october","november","december"],
			monthSmall : ["jan", "feb", "mar", "apr", "may", "jun", "jul","aug", "sep", "oct", "nov", "dec"],
	      	"main_exchange_name":{
	      		"BFO": "BFO",
	      		"NFO": "NFO",
	      		"CDS": "CDS",
	      		"BCD" : "BCD",
	      		"MCX" : "MCX",
	      		"NSE" : "NSE",
	      		"BSE" : "BSE",
	      		"NCDEX": "NCDEX"

	      	},

	      	NSEExchangeArray:['NSE', 'NFO', 'CDS'],
			BseExchangeArray:['BSE', 'BFO', 'BCD'],
			MCXArray:['MCX'],


	      }
	    },
	    methods: {
			check_if_can_delete: function(isinid){
	    		return this.$parent.checkIfExists(isinid)
	    	},

	    	deleteFromLocal: function(isinid){
	    		this.$parent.deleteFromMW(isinid)
	    	},

	    	addTolocal: function(isinid){
	    		this.$parent.addToMWIsins(isinid)
	    		this.$parent.showAdvance = -1
				this.searchResult = []
				this.$parent.searchText = ''
    			this.$parent.search_tab = 'basic'
	    	},

	    	tabwiseSearch: function(sortVia, via){

	    		if(via){
	    			let splitStr = this.search_key.split(" ")
					
					this.searchStringIsin = splitStr[0] 
					
					this.searchLocally()

					this.sortviaE = sortVia
	    		}
	    		

	    		if(sortVia == 'EQ'){
	    			this.searchResult =  this.searchResult.filter(searchCacheResult => {
						return (`${searchCacheResult.exch}` == 'NSE' || `${searchCacheResult.exch}` == 'BSE')
			        });	
	    		}
	    		else if(sortVia == 'COM'){
	    			this.searchResult =  this.searchResult.filter(searchCacheResult => {
						return (`${searchCacheResult.exch}` == 'MCX')
			        });		
	    		}
	    		else if(sortVia == 'FUT'){
	    			this.selectOption = 'fut'
					this.selectOptionFilter(true)
	    		}
	    		
	    		else if(sortVia == 'OPT'){
	    			this.searchResult =  this.searchResult.filter(searchCacheResult => {
						return (`${searchCacheResult.mn}`.toLowerCase().endsWith('ce')) || (`${searchCacheResult.mn}`.toLowerCase().endsWith('pe'))
					});	
	    		}
	    			    		
	    	},

	    	beautifyname:function(i){
				
				let option = ""

	    		let beautify = i.mn


	    		if('strikePrice' in i){

	    			// let expDate = i.expiryDate.split(",")[0].replace(",", "")	

	    			let expDate = i.expiryDate.split("-")

	    			expDate = expDate[0]+" "+expDate[1]

	    			if(i.mn.toLowerCase().endsWith('ce')){
		    			option = "CE"
		    		}
		    		else if(i.mn.toLowerCase().endsWith('pe')){
		    			option = "PE"
		    		}
		    		else if(i.mn.toLowerCase().endsWith('fut')){
		    			option = "FUT"
		    		}

		    		let strikePrice = i.strikePrice.toString()
		    		

		    		if(parseInt(strikePrice) !== 0 && parseInt(strikePrice) !== -1){
		    			beautify = i.Scripname +" "+ expDate + " "+ strikePrice +" "+option	
		    		}else{
		    			beautify = i.Scripname +" "+ expDate + " "+option
		    		}
	    		}

				return beautify
	    	},

	    	searchLocally() {
		    	try{

		    		/*if("NSE" in this.exchEnabled){
		    			this.exchEnabled = [...this.exchEnabled, ...this.NSEExchangeArray]
		    		}
		    		if("BSE" in this.exchEnabled){
		    			this.exchEnabled = [...this.exchEnabled, ...this.BseExchangeArray]
		    		}*/

		    		this.exchEnabled = ['NFO', 'NSE', 'CDS', 'BFO', 'BSE', 'MCX', 'BCD']
					this.searchResult =  this.$store.getters[PriceFeedProviderConst.GET_SEARCH_BY].filter(searchCacheResult => {
						return (`${searchCacheResult.mn}`.toLowerCase().startsWith(this.searchStringIsin.toLowerCase()) && this.exchEnabled.indexOf(`${searchCacheResult.exch}`) != -1 )    				
			        });	

			        this.searchResult.sort(function(a,b){
					  // Turn your strings into dates, and then subtract them
					  // to get a value that is either negative, positive, or zero.
					  // console.log(a)
					  if('dateExp' in a && 'dateExp' in b){
					  	return new Date(a.expiryDate) - new Date(b.expiryDate);	
					  }else{
					  	return true	
					  }
					  
					});
				}catch(e){
		    		this.searchResult = []
		    		
		    	}
			},

			checkwhattoCall(){

				if(this.search_key == ''){
					this.$parent.showAdvance = -1
					this.searchResult = []
					this.$parent.searchText = ''
	    			this.$parent.search_tab = 'basic'
				}else{



					let splitStr = this.search_key.split(" ")
					
					this.searchStringIsin = splitStr[0] 
					
					this.searchLocally()

					this.$parent.showAdvance = 1
	    			this.$parent.searchText = splitStr[0]
	    			this.$parent.search_tab = 'basic'

					this.selectOption = ''
					this.selectExpiry = ''
					this.strikePriceValue = ''
					this.select_exch = ''

					if(splitStr.length > 1){

						
						for (var i = 1; i < splitStr.length; i++) {
							
							if(splitStr[i] != ''){
								if(splitStr[i].toLowerCase() == 'call' || splitStr[i].toLowerCase() == 'ce'){
									this.selectOption = 'ce'
									this.selectOptionFilter(true)
								}
								else if(splitStr[i].toLowerCase() == 'put' || splitStr[i].toLowerCase() == 'pe'){
									this.selectOption = 'pe'
									this.selectOptionFilter(true)
								}
								else if(splitStr[i].toLowerCase() == 'future' || splitStr[i].toLowerCase() == 'fut'){
									this.selectOption = 'fut'
									this.selectOptionFilter(true)
								}

								else if(splitStr[i].toLowerCase() == 'eq' || splitStr[i].toLowerCase() == 'equity'){
									this.selectOption = 'eq'
									this.selectOptionFilter(true)
								}
								

								if(this.monthBig.indexOf(splitStr[i].toLowerCase()) !=-1){
									this.selectExpiry = splitStr[i].toLowerCase().substring(0, 3)
									this.searchExpiry(true)
								}
								else if(this.monthSmall.indexOf(splitStr[i].toLowerCase()) !=-1){
									this.selectExpiry = splitStr[i].toLowerCase()
									this.searchExpiry(true)
								}

								if(!(isNaN(splitStr[i]))) {

									if(parseInt(splitStr[i]) < 31){
										if(this.selectExpiry == ''){
											this.selectExpiry = splitStr[i]
										}else{
											this.selectExpiry = splitStr[i]+" "+this.selectExpiry		
										}
										console.log("this.selectExpiry", this.selectExpiry)									
										this.searchExpiry(true)
									}else{
										this.strikePriceValue = splitStr[i]
										this.strikePriceFilter(true)	
									}
								}

								if(this.NSEExchangeArray.indexOf(splitStr[i].toUpperCase()) != -1){
									this.select_exch = this.NSEExchangeArray
									this.filterViaExch(true)
								}
								else if(this.BseExchangeArray.indexOf(splitStr[i].toUpperCase()) != -1){
									this.select_exch = this.BseExchangeArray
									this.filterViaExch(true)
								}
								else if(this.MCXArray.indexOf(splitStr[i].toUpperCase()) != -1){
									this.select_exch = this.MCXArray
									this.filterViaExch(true)
								}

							}
						}
						// if(splitStr[1].toLowerCase() == 'call' || splitStr[1].toLowerCase() == 'ce'){
						// 	this.selectOption = 'ce'
						// 	this.selectOptionFilter(true)
						// }
						// else if(splitStr[1].toLowerCase() == 'put' || splitStr[1].toLowerCase() == 'pe'){
						// 	this.selectOption = 'pe'
						// 	this.selectOptionFilter(true)
						// }
						// else if(splitStr[1].toLowerCase() == 'future' || splitStr[1].toLowerCase() == 'fut'){
						// 	this.selectOption = 'fut'
						// 	this.selectOptionFilter(true)
						// }

					}

					if(this.sortviaE !== 'ALL' && this.sortviaE !== ''){
						this.tabwiseSearch(this.sortviaE, false)
					}
				}
			},

			searchExpiry(form) {

				// this.selectExpiry = this.selectExpiry.trim();

	    		this.searchResult =  this.searchResult.filter(searchCacheResult => {
					return (`${searchCacheResult.expiryDate}`.toLowerCase().indexOf(this.selectExpiry.toLowerCase())) > -1
				});
			},

			selectOptionFilter(form){
				
				// this.selectOption = this.selectOption.trim();

				this.searchResult =  this.searchResult.filter(searchCacheResult => {
					return (`${searchCacheResult.mn}`.toLowerCase().endsWith(this.selectOption.toLowerCase()))
				});	
					
			},
			strikePriceFilter(form){

				// this.strikePriceValue = this.strikePriceValue.trim();
				this.searchResult =  this.searchResult.filter(searchCacheResult => {
					return (`${searchCacheResult.strikePrice}`.startsWith(this.strikePriceValue))
				});
					
			},
			
	    	filterViaExch: function(form){

	    		// console.log("this.select_exch", this.select_exch)
				this.searchResult =  this.searchResult.filter(searchCacheResult => {
					return this.select_exch.indexOf(`${searchCacheResult.exch}`) > -1
		        });
			},

			afterEmptyFilter(){

				this.searchLocally()

				if(this.strikePriceValue !==''){
					this.strikePriceFilter(true)
				}
				if(this.selectOption !==''){
					this.selectOptionFilter(true)
				}
				if(this.selectExpiry !== ''){
					this.searchExpiry(true)
				}
				if(this.select_exch !== '-1'){
					this.filterViaExch(true)
				}
			},

	  	},
	  	
	  	computed: {

			selectedSearchType(){
				return this.$parent.search_tab
			},
		},
		watch: {
          search_text: {
              handler: function(val, oldVal) {
                this.search_key = val
                this.checkwhattoCall()
              },
              deep: true
          },

        }, 
	   	mounted() {
	      

	    },
 
  	}
</script>


// WEBPACK FOOTER //
// src/components/prism/shared/search_bar.vue